export default __webpack_public_path__ + "static/media/baner-top_siatka_2027.3dc4b580.jpg";